import { createUseStyles } from 'react-jss'
import { phonesDown } from '../const/breakpoints'
import { siteLink } from '../common'
import { fontWeightRegular } from '../typography'
import { darkGrey } from '../const/colors'

const useStyles = createUseStyles({
  description: {
    marginTop: [4, '!important'],
    fontSize: [12, '!important']
  },
  fieldsContainer: {
    marginTop: 24
  },
  formRow: {
    display: 'flex',
    columnGap: 10,
    '&:nth-child(2)': {
      marginBottom: 40
    }
  },

  authPageSubtitle: {
    color: darkGrey,
    fontSize: 14,
    margin: '12px auto 0',
    fontWeight: fontWeightRegular,
    '& a': {
      extend: siteLink
    }
  },
  authPageIcon: {
    marginBottom: 24
  },
  authPageFakeLink: {
    extend: siteLink
  },
  formContainer: {
    maxWidth: 405,
    margin: '40px auto 0',
    '& button': {
      marginTop: 8,
      width: '100%'
    }
  },
  authPageFooter: {
    marginTop: 40,
    textAlign: 'center'
  },
  [`@media screen and (${phonesDown})`]: {
    formContainer: {
      maxWidth: '100%'
    }
  }
})

export default useStyles
